// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as $$String from "rescript/lib/es6/string.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_format from "rescript/lib/es6/caml_format.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as BlueimpMd5 from "blueimp-md5";
import * as Experiment_Utils from "./Experiment_Utils.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Json$JsonCombinators from "@glennsl/rescript-json-combinators/src/Json.bs.js";
import * as Json_Decode$JsonCombinators from "@glennsl/rescript-json-combinators/src/Json_Decode.bs.js";

function getConsistentRank(str, prefixLength) {
  var hash = BlueimpMd5(str);
  var hashPrefix = $$String.sub(hash, 0, Caml.int_min(prefixLength, hash.length));
  try {
    return Caml_format.int_of_string("0x" + hashPrefix) % 100 + 1 | 0;
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === "Failure") {
      return 1;
    }
    throw exn;
  }
}

function getUserGroup(id, experimentId, distribution) {
  var consistentRank = getConsistentRank(experimentId + id, 4);
  var distributionSum = Belt_List.reduce(distribution, 0, (function (acc, item) {
          return acc + item[1] | 0;
        }));
  var rankOfSum = consistentRank * distributionSum / 100.0 | 0;
  var userGroup = Belt_List.reduce(distribution, [
        undefined,
        0
      ], (function (param, item) {
          var acc = param[1];
          return [
                  acc < rankOfSum && rankOfSum <= (acc + item[1] | 0) ? Caml_option.some(item[0]) : param[0],
                  acc + item[1] | 0
                ];
        }));
  return Belt_Option.getWithDefault(userGroup[0], Belt_List.getExn(distribution, 0)[0]);
}

var _map = {"WorkInProgress":"Work in progress","ReadyForUAT":"Ready for QA","ReadyForQA":"Ready for UAT","Done":"Done"};

var _revMap = {"Work in progress":"WorkInProgress","Ready for QA":"ReadyForUAT","Ready for UAT":"ReadyForQA","Done":"Done"};

function experimentStatusToJs(param) {
  return _map[param];
}

function experimentStatusFromJs(param) {
  return _revMap[param];
}

var _map$1 = {"ABTest":"[ABTest]","Toggle":"[Toggle]","Query":"[Q]"};

var _revMap$1 = {"[ABTest]":"ABTest","[Toggle]":"Toggle","[Q]":"Query"};

function experimentTypeToJs(param) {
  return _map$1[param];
}

function experimentTypeFromJs(param) {
  return _revMap$1[param];
}

function keyToJs(param) {
  return param;
}

var LocalStorage = Experiment_Utils.MakeLocalStorage({
      keyToJs: keyToJs,
      keys: {
        hd: "ABT",
        tl: /* [] */0
      }
    });

function MakeExperimentStore(T) {
  var experiments = {
    contents: /* [] */0
  };
  var getExperiments = function (param) {
    return experiments.contents;
  };
  var experimentsToJson = function (experiments) {
    return Js_dict.fromList(Belt_List.map(experiments, (function (experiment) {
                      return [
                              experiment.id,
                              Belt_Option.getWithDefault(experiment.group.contents, "")
                            ];
                    })));
  };
  var getExperiment = function (experimentId) {
    return Belt_List.reduce(experiments.contents, undefined, (function (current, experiment) {
                  if (experiment.id === experimentId) {
                    return experiment;
                  } else {
                    return current;
                  }
                }));
  };
  var updateExperimentsSession = function (param) {
    Curry._1(T.analyticsIdentifyUser, experimentsToJson(experiments.contents));
    Curry._1(T.sessionStorageSet, experimentsToJson(Belt_List.keep(experiments.contents, (function (experiment) {
                    return experiment.isForced.contents;
                  }))));
  };
  var selectExperiment = function (experimentId, groupName) {
    var experiment = getExperiment(experimentId);
    if (experiment !== undefined) {
      experiment.group.contents = groupName;
      experiment.isForced.contents = true;
    }
    updateExperimentsSession(undefined);
  };
  var getFromSessionStorage = function (param) {
    var sessionExperiments = Curry._1(T.sessionStorageGet, undefined);
    if (sessionExperiments !== undefined) {
      return Belt_List.forEach(experiments.contents, (function (experiment) {
                    try {
                      var json = Json$JsonCombinators.parseExn(sessionExperiments);
                      var decoder = Json_Decode$JsonCombinators.object(function (field) {
                            return {
                                    groupName: field.optional(experiment.id, Json_Decode$JsonCombinators.string)
                                  };
                          });
                      var decodedJson = Json_Decode$JsonCombinators.decode(json, decoder);
                      if (decodedJson.TAG !== /* Ok */0) {
                        return ;
                      }
                      var group = decodedJson._0.groupName;
                      if (group !== undefined) {
                        return selectExperiment(experiment.id, group);
                      } else {
                        return ;
                      }
                    }
                    catch (exn){
                      return ;
                    }
                  }));
    }
    
  };
  var getFromQueryParams = function (param) {
    Belt_List.forEach(Experiment_Utils.QueryString.getAllQueryParams(undefined), (function (param) {
            var isQuery = Js_string.substring(0, 4, param[0]) === experimentTypeToJs("Query") + "-";
            if (isQuery) {
              return selectExperiment(param[0], param[1]);
            }
            
          }));
  };
  var setExperimentGroups = function (param) {
    Belt_List.forEach(experiments.contents, (function (experiment) {
            experiment.group.contents = getUserGroup(Curry._1(T.getUserIdentifier, undefined), experiment.id, experiment.groupDistribution);
          }));
  };
  var init = function (param) {
    setExperimentGroups(undefined);
    getFromSessionStorage(undefined);
    getFromQueryParams(undefined);
    Curry._1(T.analyticsIdentifyUser, experimentsToJson(experiments.contents));
  };
  var getExperimentGroup = function (experimentId) {
    var experiment = getExperiment(experimentId);
    if (experiment !== undefined) {
      return Belt_Option.getWithDefault(experiment.group.contents, "");
    } else {
      return "";
    }
  };
  var addExperiment = function (id, name, status, groupDistribution) {
    experiments.contents = {
      hd: {
        id: id,
        name: name,
        group: {
          contents: undefined
        },
        groupDistribution: groupDistribution,
        isForced: {
          contents: false
        },
        status: status
      },
      tl: experiments.contents
    };
  };
  return {
          experiments: experiments,
          getExperiments: getExperiments,
          experimentsToJson: experimentsToJson,
          getExperiment: getExperiment,
          updateExperimentsSession: updateExperimentsSession,
          selectExperiment: selectExperiment,
          getFromSessionStorage: getFromSessionStorage,
          getFromQueryParams: getFromQueryParams,
          setExperimentGroups: setExperimentGroups,
          init: init,
          getExperimentGroup: getExperimentGroup,
          addExperiment: addExperiment
        };
}

function MakeExperimentStoreForWeb($star) {
  var getUserIdentifier = function (param) {
    var analytics = window.analytics;
    if (analytics === undefined) {
      return "";
    }
    var user = Caml_option.valFromOption(analytics).user();
    if (user !== undefined) {
      return Caml_option.valFromOption(user).anonymousId();
    } else {
      return "";
    }
  };
  var analyticsIdentifyUser = function (experimentGroups) {
    var analytics = window.analytics;
    if (analytics !== undefined) {
      Caml_option.valFromOption(analytics).identify(undefined, Caml_option.some(experimentGroups), undefined);
      return ;
    }
    
  };
  var experiments = {
    contents: /* [] */0
  };
  var getExperiments = function (param) {
    return experiments.contents;
  };
  var experimentsToJson = function (experiments) {
    return Js_dict.fromList(Belt_List.map(experiments, (function (experiment) {
                      return [
                              experiment.id,
                              Belt_Option.getWithDefault(experiment.group.contents, "")
                            ];
                    })));
  };
  var getExperiment = function (experimentId) {
    return Belt_List.reduce(experiments.contents, undefined, (function (current, experiment) {
                  if (experiment.id === experimentId) {
                    return experiment;
                  } else {
                    return current;
                  }
                }));
  };
  var updateExperimentsSession = function (param) {
    analyticsIdentifyUser(experimentsToJson(experiments.contents));
    var experiments$1 = experimentsToJson(Belt_List.keep(experiments.contents, (function (experiment) {
                return experiment.isForced.contents;
              })));
    Curry._2(LocalStorage.setItem, "ABT", JSON.stringify(experiments$1));
  };
  var selectExperiment = function (experimentId, groupName) {
    var experiment = getExperiment(experimentId);
    if (experiment !== undefined) {
      experiment.group.contents = groupName;
      experiment.isForced.contents = true;
    }
    updateExperimentsSession(undefined);
  };
  var getFromSessionStorage = function (param) {
    var sessionExperiments = Curry._1(LocalStorage.getItem, "ABT");
    if (sessionExperiments !== undefined) {
      return Belt_List.forEach(experiments.contents, (function (experiment) {
                    try {
                      var json = Json$JsonCombinators.parseExn(sessionExperiments);
                      var decoder = Json_Decode$JsonCombinators.object(function (field) {
                            return {
                                    groupName: field.optional(experiment.id, Json_Decode$JsonCombinators.string)
                                  };
                          });
                      var decodedJson = Json_Decode$JsonCombinators.decode(json, decoder);
                      if (decodedJson.TAG !== /* Ok */0) {
                        return ;
                      }
                      var group = decodedJson._0.groupName;
                      if (group !== undefined) {
                        return selectExperiment(experiment.id, group);
                      } else {
                        return ;
                      }
                    }
                    catch (exn){
                      return ;
                    }
                  }));
    }
    
  };
  var getFromQueryParams = function (param) {
    Belt_List.forEach(Experiment_Utils.QueryString.getAllQueryParams(undefined), (function (param) {
            var isQuery = Js_string.substring(0, 4, param[0]) === experimentTypeToJs("Query") + "-";
            if (isQuery) {
              return selectExperiment(param[0], param[1]);
            }
            
          }));
  };
  var setExperimentGroups = function (param) {
    Belt_List.forEach(experiments.contents, (function (experiment) {
            experiment.group.contents = getUserGroup(getUserIdentifier(undefined), experiment.id, experiment.groupDistribution);
          }));
  };
  var init = function (param) {
    setExperimentGroups(undefined);
    getFromSessionStorage(undefined);
    getFromQueryParams(undefined);
    analyticsIdentifyUser(experimentsToJson(experiments.contents));
  };
  var getExperimentGroup = function (experimentId) {
    var experiment = getExperiment(experimentId);
    if (experiment !== undefined) {
      return Belt_Option.getWithDefault(experiment.group.contents, "");
    } else {
      return "";
    }
  };
  var addExperiment = function (id, name, status, groupDistribution) {
    experiments.contents = {
      hd: {
        id: id,
        name: name,
        group: {
          contents: undefined
        },
        groupDistribution: groupDistribution,
        isForced: {
          contents: false
        },
        status: status
      },
      tl: experiments.contents
    };
  };
  return {
          experiments: experiments,
          getExperiments: getExperiments,
          experimentsToJson: experimentsToJson,
          getExperiment: getExperiment,
          updateExperimentsSession: updateExperimentsSession,
          selectExperiment: selectExperiment,
          getFromSessionStorage: getFromSessionStorage,
          getFromQueryParams: getFromQueryParams,
          setExperimentGroups: setExperimentGroups,
          init: init,
          getExperimentGroup: getExperimentGroup,
          addExperiment: addExperiment
        };
}

function MakeExperiment(T) {
  var nameWithOutWhitespaces = Js_string.replaceByRe(/\s+/g, "", T.name);
  var match = T.type_;
  var id = match === "Query" ? experimentTypeToJs("Query") + ("-" + nameWithOutWhitespaces) : (
      match === "ABTest" ? experimentTypeToJs("ABTest") + ("-" + nameWithOutWhitespaces) : experimentTypeToJs("Toggle") + ("-" + nameWithOutWhitespaces)
    );
  var name = T.name;
  var groupDistribution = T.groupDistribution;
  var getExperimentGroup = function (param) {
    var group = Curry._1(T.groupFromJs, Curry._1(T.ExperimentStore.getExperimentGroup, id));
    if (group !== undefined) {
      return Caml_option.valFromOption(group);
    } else {
      return Belt_List.getExn(groupDistribution, 0)[0];
    }
  };
  var getExperimentGroupToString = function (param) {
    return Curry._1(T.ExperimentStore.getExperimentGroup, id);
  };
  var status = T.status;
  Curry._4(T.ExperimentStore.addExperiment, id, name, status, Belt_List.map(groupDistribution, (function (item) {
              return [
                      Curry._1(T.groupToJs, item[0]),
                      item[1]
                    ];
            })));
  return {
          nameWithOutWhitespaces: nameWithOutWhitespaces,
          id: id,
          name: name,
          groupDistribution: groupDistribution,
          getExperimentGroup: getExperimentGroup,
          getExperimentGroupToString: getExperimentGroupToString,
          status: status
        };
}

export {
  getConsistentRank ,
  getUserGroup ,
  experimentStatusToJs ,
  experimentStatusFromJs ,
  experimentTypeToJs ,
  experimentTypeFromJs ,
  LocalStorage ,
  MakeExperimentStore ,
  MakeExperimentStoreForWeb ,
  MakeExperiment ,
}
/* LocalStorage Not a pure module */
